import { render, staticRenderFns } from "./TherapistShortInfo.vue?vue&type=template&id=604dc3b8&scoped=true"
import script from "./TherapistShortInfo.vue?vue&type=script&lang=js"
export * from "./TherapistShortInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604dc3b8",
  null
  
)

export default component.exports